import React, { useEffect, useState } from "react";
import InputText from "../../components/input/InputText";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import {
  setChangeEmailPopup,
  setProfilePicNav,
} from "../../redux/features/dataSlice";
import Datepicker from "../../components/datepicker/Datepicker";
import Avatar from "../../layout/popup/PopupInfoDiet/Avatar";
import { authAPI, searchAPI } from "../../apis";
import AvatarSelector from "./AvatarSelector";
import CloseIcon from "@mui/icons-material/Close";

import CustomLoader from "../../components/loader";
import Cropper from "./Cropper";
import PopupChangeEmail from "../../layout/popup/PopupChangeEmail";
import ChangePassword from "../ChangePassword";
import { axiosInstance } from "../../functions/axios";

const Settings = () => {
  const { user } = useSelector((state) => state.auth);
  const { datePicker } = useSelector((state) => state.data);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [avatarId, setAvatarId] = useState(0);
  const [errorText, setErrorText] = useState("");
  const [changePic, setChangePic] = useState(false);
  const [email, setEmail] = useState(localStorage.getItem("email"));
  const [avatars, setAvatars] = useState([]);
  const [showAvatarSelector, setShowAvatarSelector] = useState(false);
  const [profileData, setProfileData] = useState({});
  const [loading, setLoading] = useState(true);
  const [blob, setBlob] = useState([]);

  const fileInputRef = React.useRef(null);
  const dispatch = useDispatch();

  const formatFormData = () => {
    const formData = new FormData();
    changePic && formData.append("ProfilePicture", blob);
    // notIsProfileRequired && formData.append("IsProfileRequired", false);
    // avatarId && formData.append("AvatarId", avatarId);
    formData.append("UserId", user.userId);
    formData.append("FirstName", firstName);
    formData.append("LastName", lastName);
    formData.append("UserName", username);

    return formData;
  };

  const checkError = (message) => {
    if (
      message ===
      "The username contains profanity. Please choose a different username."
    ) {
      toast.error(message);
    } else {
      toast.error("Error while updating profile.");
    }
  };

  const updateProfile = async () => {
    const check = await checkUniqueUsername();
    if (!check) {
      toast.error("Username validation failed!");
      return;
    }
    setLoading(true);
    try {
      const formData = formatFormData();

      const { data } = await axiosInstance.post(
        authAPI.updateProfile,
        formData,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setErrorText("");
      setChangePic(false);
      dispatch(setProfilePicNav((prev) => !prev));
      toast.success("Profile updated successfully.");
    } catch (e) {
      console.log(e);
      checkError(e.response.data);
    }
    getData();
    setLoading(false);
  };

  const updateProfilePic = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      changePic && formData.append("ProfilePicture", blob);
      formData.append("UserId", user.userId);

      await axiosInstance.post(authAPI.updateProfile, formData, {
        headers: {
          Authorization: `Bearer ${user.token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setErrorText("");
      setChangePic(false);
      dispatch(setProfilePicNav((prev) => !prev));
      toast.success("Profile updated successfully.");
      setAvatarId(0);
    } catch (e) {
      console.log(e);
      checkError(e.response.data);
    }
    getData();
    setLoading(false);
  };

  const deleteProfilePic = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("IsProfileRequired", false);
      formData.append("UserId", user.userId);

      await axiosInstance.post(authAPI.updateProfile, formData, {
        headers: {
          Authorization: `Bearer ${user.token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch(setProfilePicNav((prev) => !prev));
      toast.success("Profile Pic deleted successfully.");
    } catch (e) {
      console.log(e);
      checkError(e.response.data);
    }
    getData();
    setLoading(false);
  };

  const checkUniqueUsername = async () => {
    try {
      let url;
      if (username.length === 0) {
        setErrorText(`Username cannot be empty.`);
        return false;
      }
      if (user) {
        url = `${authAPI.uniqueUsername}?userName=${username}&userId=${user.userId}`;
      } else {
        url = `${authAPI.uniqueUsername}?userName=${username}`;
      }
      const { data } = await axiosInstance.get(url);
      setErrorText("");
      return true;
    } catch (e) {
      setErrorText(e.response.data);
      console.log(e);
      return false;
    }
  };

  const getData = async () => {
    const { data } = await axiosInstance.get(
      `${authAPI.getUserDetails}?userId=${user.userId}`,
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    setFirstName(data.firstName);
    setLastName(data.lastName);
    setUsername(data.userName);
    setProfilePic(data.profilePictureUrl);
    setAvatars(data.avatars);
    setProfileData(data);
    setLoading(false);
  };

  const handleAvatarSelect = (url, id) => {
    setProfilePic(url);
    setAvatarId(id);
    setChangePic(true);
    setShowAvatarSelector(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="settings-page">
      {loading ? (
        <CustomLoader height="100vh" style={true} />
      ) : (
        <div className="settings-container">
          <div className="box">
            <Cropper
              setChangePic={setChangePic}
              preview={profilePic}
              setPreview={setProfilePic}
              setBlob={setBlob}
              setShowAvatarSelector={setShowAvatarSelector}
              showAvatarSelector={showAvatarSelector}
              avatars={avatars}
              handleAvatarSelect={handleAvatarSelect}
              updateProfilePic={updateProfilePic}
              setAvatarId={setAvatarId}
              username={profileData.userName}
              email={profileData.email}
              deleteProfilePic={deleteProfilePic}
            />
            <div className="flex-col">
              <p className="label">Settings</p>
              <div className="label-indicator" />
            </div>
            <div className="divider" />
            <div className="container">
              <p className="title">Basic Information</p>
              <div className="container-divider" />
              <div className="field">
                {/* <main className="flex-basic-field">
                  <p>Name:</p>
                  <p>(Optional)</p>
                </main> */}
                {/* <InputText
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  placeholder="First Name (Optional)"
                />
                <InputText
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  placeholder="Last Name (Optional)"
                /> */}
              </div>
              <div className="field">
                <main className="flex-basic-field">
                  <p>Username:</p>
                  <p>(Required)</p>
                </main>
                <InputText
                  value={username}
                  validation={`username`}
                  onChange={(e) => setUsername(e.target.value)}
                  errorText={errorText}
                  setErrorText={setErrorText}
                  placeholder="Username"
                />
              </div>
              <p className="message">{errorText}</p>
              <div className="container-divider mt-2" />

              <div className="save-button">
                <ButtonPrimary text="Save" onClick={updateProfile} />
              </div>
            </div>
            <div className="container">
              <PopupChangeEmail email={email} setEmail={setEmail} />
            </div>
            <div className="container">
              <ChangePassword />
            </div>
          </div>
        </div>
      )}
      {datePicker && <Datepicker />}
    </div>
  );
};

export default Settings;
